import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';
import {scrollToSectionTop} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';

const CONTENT_SECTION_SELECTOR = 'div.notebookContent__body';

/**
 * Footer: Foooter Component for Notebook Contents
 * Display the NextSection & End Simulations buttons
 */
export function Footer(props) {
  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!props.lastSection) {
      scrollToSectionTop(CONTENT_SECTION_SELECTOR);
      props.toNextSection();
    }
  };

  return (
    <div className='notebookContent__footer'>
      <Button className='nextSection' onClick={onClick}>
        {props.lastSection ? `End Simulation` : `Next Section`}
      </Button>
    </div>
  );
}

Footer.propTypes = {
  /**
   * Boolean to specify if its the last section
   */
  lastSection: PropTypes.bool.isRequired,
  /**
   * Function to invoke when NextSection button is clicked
   */
  toNextSection: PropTypes.func.isRequired,
};

Footer.defaultProps = {
  lastSection: true,
};
